import { connect } from 'redux-bundler-react';
import { useModal } from '@stores';
import { ModalContent, ModalFooter } from '@components/secondary-modal';
import SelectInput from '@components/select/Select';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm, FormProvider } from 'react-hook-form';
import { useGetDistrictLocationFromGeometry } from '@api/services/aor/hooks';

const schema = yup.object().shape({
  district: yup.string().required('Field is required'),
});

const DistrictModal = connect('selectRequestFormDataLocation', ({ requestFormDataLocation, setDistrict }) => {
  const { closeSecondaryModal } = useModal();
  const districtsLocations = useGetDistrictLocationFromGeometry(requestFormDataLocation?.geometry);
  const districtOptions = [...new Set(districtsLocations?.map((d) => d.district) || [])];

  const methods = useForm({ resolver: yupResolver(schema), mode: 'onBlur' });
  const {
    formState: { isValid },
    watch,
  } = methods;

  const district = watch('district');

  const saveDistrict = () => {
    setDistrict(district);
    closeSecondaryModal();
  };

  return (
    <FormProvider {...methods}>
      <ModalContent title='Select a USACE Regulatory District'>
        <section className='modal-body'>
          <p>
            This project spans multiple USACE Regulatory Districts, Please select the lead district from the dropdown
            below.
          </p>
          <SelectInput name='district' label='Lead District' options={districtOptions} required />
        </section>
        <ModalFooter
          saveText='Confirm District'
          saveIsDisabled={!isValid}
          customClosingLogic
          onSave={() => saveDistrict()}
        />
      </ModalContent>
    </FormProvider>
  );
});

export default DistrictModal;
